<template>
  <div>
    <!-- 标题 -->
    <h2>文件信息管理</h2>
    <!-- 筛选条件 -->
    <el-row :gutter="20" style="margin-bottom: 20px;">
      <el-col :span="8">
        <el-select v-model="filter.type" placeholder="选择文件类型" clearable>
          <el-option value="" label="全部" />
          <el-option value="image" label="图片" />
          <el-option value="video" label="视频" />
        </el-select>
      </el-col>
      <el-col :span="8">
        <el-input v-model="filter.name" placeholder="请输入文件名" clearable />
      </el-col>
      <el-col :span="8">
        <el-button type="primary" @click="getFiles">查询</el-button>
        <el-button @click="resetFilters">重置</el-button>
      </el-col>
    </el-row>
    <!-- 添加按钮 -->
    <el-row style="margin-bottom: 20px;">
      <el-col :span="24">
        <el-button type="primary" icon="el-icon-plus" @click="showUploadDialog">上传文件</el-button>
      </el-col>
    </el-row>
 <!-- 编辑文件名弹框 -->
    <el-dialog title="编辑文件名" v-model="editDialogVisible">
      <el-form :model="editForm" label-width="100px">
        <el-form-item label="文件名">
          <el-input v-model="editForm.name" placeholder="请输入文件名" size="small" />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">确认</el-button>
      </div>
    </el-dialog>
    <!-- 文件信息表格 -->
    <el-table :data="files" border style="width: 100%">
      <!-- 文件展示列 -->
      <el-table-column label="文件展示" width="300">
        <template v-slot="{ row }">
          <div v-if="row.type === 'image'" class="file-display">
            <img :src="row.url" alt="图片预览" class="file-image" />
          </div>
          <div v-else-if="row.type === 'video'" class="file-display">
            <video :src="row.url || row.url" alt="视频封面" class="file-image" />
          </div>
        </template>
      </el-table-column>

      <!-- 文件名称 -->
      <el-table-column prop="name" label="文件名称" width="200">
        <template v-slot="{ row }">
          <el-input v-model="row.name" size="small" disabled />
        </template>
      </el-table-column>

      <el-table-column  v-if="filter.type === 'video'" prop="status" label="审核状态" width="200">
        <template v-slot="{ row }">
          <el-tag
              :type="row.status === 0 ? 'warning' : row.status === 1 ? 'success' : 'danger'"
              size="small"
          >
            {{ row.status === 0 ? '待审核' : row.status === 1 ? '已通过' : '拒绝' }}
          </el-tag>
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column label="操作" width="150">
        <template v-slot="{ row }">
          <div style="display: flex; align-items: center; gap: 0;">
            <el-button type="text" size="small" style="padding: 0;" @click="editFile(row)">编辑</el-button>
            <el-button type="text" size="small" style="padding: 0;" @click="deleteFile(row)">删除</el-button>
            <el-button
                type="text"
                size="small"
                style="padding: 0;"
                @click="showCancelShow(row)"
            >
              {{ row.showing ? '取消展示' : '展示' }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <el-pagination
        background
        layout="prev, pager, next, sizes, total"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @current-change="handlePageChange"
        @size-change="handlePageSizeChange"
    />


    <!-- 上传文件弹框 -->
    <el-dialog title="上传文件" v-model="uploadDialogVisible">
      <el-form :model="uploadForm" label-width="100px">
        <el-form-item label="文件类型">
          <el-radio-group v-model="uploadForm.fileType">
            <el-radio label="image">图片</el-radio>
            <el-radio label="video">视频</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="选择文件">
          <el-upload
            ref="fileUploader"
            :auto-upload="false"
            :limit="1"
            :on-change="handleFileChange"
            :before-upload="beforeUpload"
            :file-list="fileList"
            action="#"
          >
            <el-button type="primary">选择文件</el-button>
          </el-upload>
          <!-- 文件名展示 -->
          <div v-if="selectedFileName" style="margin-top: 20px;">
            <span>已选择文件：</span>
            <b>{{ selectedFileName }}</b>
          </div>
        </el-form-item>

        <el-form-item label="自定义文件名">
          <el-input v-model="uploadForm.customFileName" placeholder="请输入文件名" size="small" />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="uploadDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitUpload">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/axios";
import { ElMessage } from "element-plus";

export default {
  props: {
    userid: {
      type: Number,
      required: true,
    },
    organizationID: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      total:0,
      editDialogVisible :false,
      editForm:{name:'',id:'',type:''},
      files: [], // 文件列表
      uploadDialogVisible: false, // 上传弹框显示���制
      uploadForm: {
        fileType: "image", // 默认上传类型为图片
        customFileName: "", // 自定义文件名
      },
       // 筛选条件
      filter: {
        type: "", // 文件类型 (image, video, 或空)
        name: "", // 文件名称 (模糊搜索)
      },

      // 分页相关
      currentPage: 1, // 当前页码
      pageSize: 5, // 每页显示数量
      fileList: [], // 文件列表
      selectedFileName: "", // 用于显示的文件名
      orgId: this.organizationID, // 组织ID
      userId: this.userid, // 用户ID
      imageUploadUrl: "http://localhost:999/images/upload",
      videoUploadUrl: "http://localhost:999/videos/upload",


    };
  },

  methods: {
    // 打开上传文件弹框
    showUploadDialog() {
      this.uploadDialogVisible = true;
    },

    // 修改文件选择处理方法
    handleFileChange(file) {
      // 保存最新选择的文件
      this.fileList = [file];
      this.selectedFileName = file.name;
    },

    // 修改文件上传前的验证方法
    beforeUpload(file) {
      const isImage = this.uploadForm.fileType === "image" && file.type.startsWith("image/");
      const isVideo = this.uploadForm.fileType === "video" && file.type.startsWith("video/");
      const isValid = isImage || isVideo;

      if (!isValid) {
        ElMessage.error("文件类型不符合要求");
        return false;
      }

      const maxSize = this.uploadForm.fileType === "image" ? 10 : 500;
      const isLtSize = file.size / 1024 / 1024 < maxSize;
      if (!isLtSize) {
        ElMessage.error(`文件大小不能超过 ${maxSize}MB`);
        return false;
      }

      // 不要在这里修改 fileList，让 handleFileChange 处理
      return true;
    },

    // 处理分页变更
    handlePageChange(page) {
      this.currentPage = page;
      this.getFiles(); // 页码变化重新获取数据
    },

    // 每页数量变化
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1; // 重置为第一页
      this.getFiles();
    },
    // 修改提交上传方法
    submitUpload() {
      if (!this.fileList.length || !this.fileList[0]) {
        ElMessage.error("请选择文件后再提交");
        return;
      }

      const file = this.fileList[0];
      if (!file.raw) {
        ElMessage.error("文件对象无效");
        return;
      }

      const customName = this.uploadForm.customFileName;
      const fileName = customName || file.name;

      // 确保文件名包含正确的后缀
      const extension = file.name.split(".").pop();
      const finalFileName = customName ? `${customName}.${extension}` : fileName;

      const formData = new FormData();
      formData.append("file", file.raw);
      formData.append("organizationId", this.orgId);
      formData.append("userId", this.userId);
      formData.append("fileName", finalFileName);

      const uploadUrl = this.uploadForm.fileType === "image" ? this.imageUploadUrl : this.videoUploadUrl;

      // 添加请求头
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };

      axios.post(uploadUrl, formData, config)
        .then((response) => {
          if(response.data.success) {
            this.getFiles();
            ElMessage.success(response.data.data);
            this.uploadDialogVisible = false;
            this.fileList = [];
            this.selectedFileName = '';
            this.uploadForm.customFileName = "";
          } else {
            ElMessage.error(response.data.errorMsg);
          }
        })
        .catch((error) => {
          ElMessage.error("文件上传失败");
          console.error(error);
        });
    },
editFile(row){
      this.editDialogVisible = true;
      this.editForm.name = row.name
  this.editForm.id=row.id
  this.editForm.type=row.type
},
      // 提交编辑文件名
  submitEdit() {
      let url
if(this.editForm.type === 'image'){
  url = '/images/update'
}else if(this.editForm.type === 'video'){
  url = '/videos/update'}

else { ElMessage.error('未知错误');
return}



      axios
        .get(url, {params:{ newName: this.editForm.name, id: this.editForm.id,
          userId: this.userId,organizationId: this.orgId}})
        .then((res) => {
          if(res.data.success) {
            ElMessage.success(res.data.data);
            this.getFiles()
            this.editDialogVisible = false;  // 关闭编辑弹框}
          }else {
            ElMessage.error(res.data.errorMsg);
          }
        })
        .catch((error) => {
          this.$message.error("更新文件名失败");
          console.error(error);
        });

  },
    showCancelShow(file){
      console.log(file.id)
      if(file.type === 'image') {
        axios.post(`/images/cancelShow/${file.id}`).then(response => {
          if (response.data.success) {
            this.getFiles()
            ElMessage.success("操作成功");
          } else {
            ElMessage.error(response.data.errorMsg);
          }
        }).catch(error => {
          ElMessage.error("操作失败");
        })
      }
      else if(file.type === 'video'){
        axios.post(`/videos/cancelShow/${file.id}`).then(response => {
          if (response.data.success) {
            this.getFiles()
            ElMessage.success("操作成功");
          } else {
            ElMessage.error(response.data.errorMsg);
          }
        }).catch(error => {
          ElMessage.error("操作失败");
        })
      }
    },
    // 删除文件
    deleteFile(file) {

      console.log(file.type)

      if(file.type === 'image') {
        axios
            .delete(`/images/delete/${file.id}`)
            .then((res) => {
if(res.data.success) {
  this.getFiles()
  ElMessage.success("文件删除成功");

}else {
   ElMessage.error(res.data.errorMsg);
}
            })
            .catch(() => {
              ElMessage.error("文件删除失败");
            });
      }
      else {
        axios
            .delete(`/videos/delete/${file.id}`)
            .then((res) => {
              if(res.data.success) {
                this.getFiles()
                ElMessage.success("文件删除成功");
              }
              else { ElMessage.error(res.data.errorMsg);}
            })
            .catch(() => {
              ElMessage.error("文件删除失败");
            });
      }
    },
    getFiles() {
      const params = {
        videoName: this.filter.name,
     organizationId: this.orgId,
        userId: this.userId,
        page: this.currentPage , // 后端分页从 0 开始
        size: this.pageSize,
      };
       let  urls
      if(this.filter.type === 'image'){
          urls = '/images/search'
      }
      else if(this.filter.type === 'video'){
          urls = '/videos/search'
      }
      else {
          urls = '/images/search'
      }
      axios.get(urls, {params} ).then((response) => {
          console.log(response.data.data)
this.total=response.data.total;
       this.files = response.data.data.map(file => {
         let fileType
         if( file.name===undefined){
           fileType='video';
         }
         else  fileType ='image'
  const fileName = fileType === 'video' ? file.videoName : file.name;
  const src = fileType === 'video' ? file.videoPath : file.src;
  return {
    ...file,
    name: fileName, // 统一文件名字段为 name
    type: fileType, // 加上 type 字段
    url:src
  };
});}).catch((error) => {
          this.$message.error("获取文件列表失败");
          console.error(error);
        });


    },

    // 重置筛选条件
    resetFilters() {
      this.filter.type = "";
      this.filter.name = "";
      this.applyFilters();
    },
  },

  created() {

    this.getFiles()
       console.log('zhb'+this.files)
    console.log(this.userid)
    console.log(this.organizationID)
  },

};
</script>

<style scoped>
h2 {
  margin-bottom: 20px;
}

.file-display {
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-image {
  max-width: 100px;
  max-height: 100px;
  object-fit: contain;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 5px;
}

.el-input {
  width: 100%;
}
</style>
